import { apiConfig } from '../config';
import { getFetch } from '../fetch';

export function getQuizByLesson(lessonId: string): Promise<void> {
    const { apiGetQuizByLesson } = apiConfig.getStaticUrls();

    return getFetch(`${apiGetQuizByLesson}${lessonId}/`);
}
